import React from 'react';
import { motion } from 'framer-motion';
import { Search, Filter, MoreHorizontal, CheckCircle2, Circle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const shows = [{
  date: 'Jun 12',
  venue: 'The Empty Bottle',
  city: 'Chicago, IL',
  status: 'Advancing',
  advance: '5/7',
  finance: 'Deposit received',
  value: '$1,500',
  color: 'primary'
}, {
  date: 'Jun 14',
  venue: 'Beachland Tavern',
  city: 'Cleveland, OH',
  status: 'Needs Advance',
  advance: '2/7',
  finance: 'Deposit pending',
  value: '$1,800',
  color: 'amber'
}, {
  date: 'Jun 18',
  venue: 'Higher Ground',
  city: 'Burlington, VT',
  status: 'Confirmed',
  advance: '0/7',
  finance: 'Not yet',
  value: '$2,200',
  color: 'green'
}, {
  date: 'Jun 21',
  venue: 'The Sinclair',
  city: 'Cambridge, MA',
  status: 'Confirmed',
  advance: '0/7',
  finance: 'Not yet',
  value: '$1,900',
  color: 'green'
}, {
  date: 'Mar 15',
  venue: "Antone's",
  city: 'Austin, TX',
  status: 'Completed',
  advance: '7/7',
  finance: 'Settled',
  value: '$2,000',
  color: 'blue'
}, {
  date: 'Mar 18',
  venue: 'The Continental Club',
  city: 'Austin, TX',
  status: 'Completed',
  advance: '7/7',
  finance: 'Settled',
  value: '$1,800',
  color: 'blue'
}];
export function ShowsPage() {
  const navigate = useNavigate();
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-7xl mx-auto" data-id="element-4743">
      {/* Header & Filters */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6" data-id="element-4744">
        <h2 className="text-2xl font-bold" data-id="element-4745">Shows</h2>
        <div className="flex flex-wrap items-center gap-3" data-id="element-4746">
          <div className="relative" data-id="element-4747">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-4748" />
            <input type="text" placeholder="Search shows..." className="pl-9 pr-4 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary w-64" data-id="element-4749" />
          </div>
          <select className="px-3 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary text-textMuted" data-id="element-4750">
            <option data-id="element-4751">Upcoming</option>
            <option data-id="element-4752">Past</option>
            <option data-id="element-4753">All Shows</option>
          </select>
          <button className="p-2 bg-surface border border-border rounded-lg text-textMuted hover:text-textMain transition-colors" data-id="element-4754">
            <Filter className="w-4 h-4" data-id="element-4755" />
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-4756">
        <div className="overflow-x-auto" data-id="element-4757">
          <table className="w-full text-sm text-left" data-id="element-4758">
            <thead className="bg-surface border-b border-border text-textMuted" data-id="element-4759">
              <tr data-id="element-4760">
                <th className="px-6 py-4 font-medium" data-id="element-4761">Date</th>
                <th className="px-6 py-4 font-medium" data-id="element-4762">Venue</th>
                <th className="px-6 py-4 font-medium" data-id="element-4763">City</th>
                <th className="px-6 py-4 font-medium" data-id="element-4764">Status</th>
                <th className="px-6 py-4 font-medium" data-id="element-4765">Advance Progress</th>
                <th className="px-6 py-4 font-medium" data-id="element-4766">Financial Status</th>
                <th className="px-6 py-4 text-right" data-id="element-4767">Guarantee</th>
                <th className="px-6 py-4" data-id="element-4768"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border bg-background" data-id="element-4769">
              {shows.map((show, i) => {
              const progress = parseInt(show.advance.split('/')[0]);
              const total = parseInt(show.advance.split('/')[1]);
              const percent = progress / total * 100;
              return <tr key={i} onClick={() => navigate(`/app/shows/${show.venue.toLowerCase().replace(/\s+/g, '-')}`)} className={`hover:bg-surface/50 transition-colors cursor-pointer group ${show.status === 'Completed' ? 'opacity-60' : ''}`} data-id="element-4770">
                    <td className="px-6 py-4 font-medium whitespace-nowrap" data-id="element-4771">
                      {show.date}
                    </td>
                    <td className="px-6 py-4 font-medium group-hover:text-primary transition-colors" data-id="element-4772">
                      {show.venue}
                    </td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-4773">{show.city}</td>
                    <td className="px-6 py-4" data-id="element-4774">
                      <span className={`px-2 py-1 text-xs rounded font-medium bg-${show.color}-500/10 text-${show.color}-500`} data-id="element-4775">
                        {show.status}
                      </span>
                    </td>
                    <td className="px-6 py-4" data-id="element-4776">
                      <div className="flex items-center gap-2" data-id="element-4777">
                        <div className="flex-1 h-1.5 bg-surface border border-border rounded-full overflow-hidden w-24" data-id="element-4778">
                          <div className={`h-full ${progress === total ? 'bg-green-500' : 'bg-primary'}`} style={{
                        width: `${percent}%`
                      }} data-id="element-4779"></div>
                        </div>
                        <span className="text-xs text-textMuted whitespace-nowrap" data-id="element-4780">
                          {show.advance}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-4781">
                      <div className="flex items-center gap-1.5 text-xs" data-id="element-4782">
                        {show.finance === 'Settled' || show.finance === 'Deposit received' ? <CheckCircle2 className="w-3.5 h-3.5 text-green-500" data-id="element-4783" /> : show.finance === 'Deposit pending' ? <Circle className="w-3.5 h-3.5 text-amber-500" data-id="element-4784" /> : <Circle className="w-3.5 h-3.5 text-border" data-id="element-4785" />}
                        <span className="text-textMuted" data-id="element-4786">{show.finance}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-right font-medium" data-id="element-4787">
                      {show.value}
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-4788">
                      <button className="p-1 text-textMuted hover:text-textMain transition-colors rounded hover:bg-surface" data-id="element-4789">
                        <MoreHorizontal className="w-4 h-4" data-id="element-4790" />
                      </button>
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>;
}